import $ from "jquery"

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import BasePage from "pages/base_page"

class InstitutionPage extends BasePage {
  static initClass() {
    this.prototype.events = {
      "click #tabbed-navigation a": "_handleTabClick",
    }
  }

  _handleTabClick(event) {
    event.preventDefault()
    const section = $(event.currentTarget).attr("href")

    $("#tabbed-navigation a.active").removeClass("active")
    $(event.currentTarget).addClass("active")

    switch (section) {
      case "#articles":
        $(".institution-page").removeClass("sm-display-contributors sm-display-jobs-and-events")
        $(".institution-page").addClass("sm-display-articles")
        break
      case "#contributors":
        $(".institution-page").removeClass("sm-display-articles sm-display-jobs-and-events")
        $(".institution-page").addClass("sm-display-contributors")
        break
      case "#jobs-and-events":
        $(".institution-page").removeClass("sm-display-articles sm-display-contributors")
        $(".institution-page").addClass("sm-display-jobs-and-events")
        break
      default:
        break
    }
  }
}

InstitutionPage.initClass()

export default InstitutionPage
